<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import type { FieldSchema } from '../../../types';
import { capitalizeStr } from '@Helpers';
import { GetAnimalTemplatesService, CATEGORY } from '@AnimalModule';

defineOptions({ inheritAttrs: false });

defineProps<{
  field?: FieldSchema;
}>();

const model = defineModel<string>();

const animalTemplates = ref();

const specieOptionClasses = computed(
  () =>
    'grid cursor-pointer place-content-center rounded-md h-9 border px-4 py-1.5 active:bg-brand-600 hover:bg-brand-500 transition-colors hover:text-white'
);

onMounted(() => getAnimalTemplates());

async function getAnimalTemplates() {
  GetAnimalTemplatesService().then((result: any) => {
    const priority = [CATEGORY.DOG, CATEGORY.CAT, CATEGORY.RABBIT, CATEGORY.HORSE];

    const getRank = (name: string) => {
      if (name === CATEGORY.OTHER) return 999;

      const index = priority.indexOf(name as CATEGORY);
      return index === -1 ? 100 : index;
    };

    animalTemplates.value = result
      .slice()
      .sort((a: any, b: any) => getRank(a.name) - getRank(b.name))
      .map((item: any) => ({
        name: capitalizeStr(item.label),
        value: item.name,
      }));
  });
}
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <div
      v-for="{ name, value } in animalTemplates"
      class="flex items-center"
      :key="`${name}_${value}`"
    >
      <label
        :class="[
          specieOptionClasses,
          {
            'af-button border bg-brand-500 font-semibold text-white': model === value,
          },
        ]"
        :for="`${name}_${value}`"
      >
        <RadioButton
          v-model="model"
          class="hidden"
          name="specie"
          :inputId="`${name}_${value}`"
          :value="value"
        />

        <label
          class="cursor-pointer text-sm"
          :for="`${name}_${value}`"
        >
          {{ $t(name) }}
        </label>
      </label>
    </div>
  </div>
</template>
